/** Thirty-second cadence, with two-second debounce after a major economy event. */
export class SaveSchedule {
    private lastSave = 0;
    private pending = -1;
    private signature = '';
    private money = 0;
    due(frame: number, signature: string, money: number): boolean {
        if (this.signature && (signature !== this.signature || this.money-money >= Math.max(1,this.money*.1))) this.pending = frame+120;
        this.signature = signature;this.money = money;
        if (frame-this.lastSave>=1800 || this.pending>=0 && frame>=this.pending) {
            this.lastSave = frame;this.pending = -1;return true;
        }
        return false;
    }
}
